export const LAB = {
  navLabs: "nav-labs",
  page: "labs-page",
  title: "labs-title",
  banner: "labs-reference-banner",
  table: "labs-table",
  loading: "labs-loading",
  emptyState: "labs-empty",
  errorState: "labs-error",
  row: "labs-row",
};
